import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { GYPSUM, SLINKY } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { ScreenSize } from '../responsiveness/MediaQuery';
import { useWidthMediaQueries } from '../responsiveness/useWidthMediaQueries';
import { Step } from '../views/Step';
const StyledButtonContainer = styled.div.withConfig({
  displayName: "LandingPageSignupWithEmailButton__StyledButtonContainer",
  componentId: "sc-26m1se-0"
})(["width:320px;max-width:420px;padding-top:10px;padding-bottom:64px;margin-top:18px;margin:auto;", ""], props => props.shouldUpdateContainerStyle && `width: 400px;
    margin: auto !important;
    margin-left: 13px;
    margin-right: 13px;`);
const StyledUIButton = styled(UIButton).withConfig({
  displayName: "LandingPageSignupWithEmailButton__StyledUIButton",
  componentId: "sc-26m1se-1"
})(["width:100%;height:42px;color:", " !important;border-color:", " !important;&:hover{background-color:", " !important;}"], SLINKY, SLINKY, GYPSUM);
const StyledUIIcon = styled(UIIcon).withConfig({
  displayName: "LandingPageSignupWithEmailButton__StyledUIIcon",
  componentId: "sc-26m1se-2"
})(["float:left;padding-top:9px;padding-right:12px;"]);
export const SignupWithEmailButton = ({
  onClick
}) => {
  const widthBreakpoint = useWidthMediaQueries();
  const shouldUpdateContainerStyle = widthBreakpoint > ScreenSize.XS;
  return /*#__PURE__*/_jsx(StyledButtonContainer, {
    className: "m-top-4",
    shouldUpdateContainerStyle: shouldUpdateContainerStyle,
    children: /*#__PURE__*/_jsxs(StyledUIButton, {
      use: "secondary",
      onClick: onClick,
      children: [/*#__PURE__*/_jsx(StyledUIIcon, {
        name: "email",
        size: "small"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `views.${Step.LandingPage}.signupWithEmailButtonText`
      })]
    })
  });
};